import { Criteo, CriteoActions } from "Criteo";
import * as cartActionTypes from "../actions/types/cartActionType";
import * as analytics from "../components/Analytics";

const initialState = {
	loading: false,
	loadingItem: false,
	idItem: null,
	cart: {},
	messages: [],
	error: null
};

function getMessages(state, response) {
	if (state.messages && state.messages.length > 0) return state.messages;

	return response.messages && response.messages.length > 0
		? response.messages
		: [];
}

export default function cartReducer(state = initialState, action) {
	let newState = {};

	const printMessages = function(func, messages) {
		if (messages != null && messages.length > 0) {
			for (let i = 0; i < messages.length; i++) {
				console.log(`${func}: ${messages[i].value}`);
			}
		}
	};

	switch (action.type) {
		// GetCart
		case cartActionTypes.FETCH_CART_REQUEST:
			newState = Object.assign({}, state, {
				error: null,
				messages: [],
				loading: true
			});
			return newState;

		case cartActionTypes.FETCH_CART_SUCCESS:
			analytics.Analytics.getCart(action.response ? action.response.cart : {});

			// printMessages('GetCart', action.response ? action.response.messages : []);

			newState = Object.assign({}, state, {
				loading: false,
				// cart: action.response ? action.response : {},
				messages: getMessages(state, action.response),
				cart: action.response && action.response.cart ? action.response.cart : {}
			});

			if (action.response && action.response.cart) {
				const criteoData = [];
				let cartItem;
				let price;
				action.response.cart.offers.map((offer) => {
					if (offer.cartItems && offer.cartItems.length > 0) {
						price = offer.price;
						cartItem = offer.cartItems[0];
						criteoData.push({
							id: cartItem.id,
							price,
							quantity: cartItem.amount
						});
					}
				});
				if (criteoData.length > 0)
					Criteo.push(CriteoActions.ACTIONS.Cart, criteoData);
			}

			return newState;

		case cartActionTypes.FETCH_CART_FAILURE:
			newState = Object.assign({}, state, {
				loading: false,
				messages: [],
				error: action.error,
				cart: {}
			});
			return newState;

		// RemoveFromCart
		case cartActionTypes.FETCH_REMOVEFROMCART_REQUEST:
			newState = Object.assign({}, state, {
				error: null,
				messages: []
				// loading: true,
			});
			return newState;

		case cartActionTypes.FETCH_REMOVEFROMCART_SUCCESS:
			analytics.Analytics.removeFromCart(
				action.response ? action.response.cart : {}
			);

			newState = Object.assign({}, state, {
				// loading: false,
				messages:
					action.response && action.response.messages
						? action.response.messages
						: [],
				cart: action.response && action.response.cart ? action.response.cart : {}
			});
			document.dispatchEvent(new CustomEvent("update-cart", {}));
			return newState;

		case cartActionTypes.FETCH_REMOVEFROMCART_FAILURE:
			newState = Object.assign({}, state, {
				// loading: false,
				error: action.error,
				messages: [],
				cart: {}
			});
			return newState;

		// AddToCart
		case cartActionTypes.FETCH_ADDTOCART_REQUEST:
			newState = Object.assign({}, state, {
				error: null,
				messages: []
				// loading: true,
			});
			return newState;

		case cartActionTypes.FETCH_ADDTOCART_SUCCESS:
			analytics.Analytics.addToCart(action.response ? action.response.cart : {});
			// TODO RA - REMOVER
			printMessages("AddToCart", action.response ? action.response.messages : []);

			newState = Object.assign({}, state, {
				// loading: false,
				messages:
					action.response && action.response.messages
						? action.response.messages
						: [],
				cart: action.response && action.response.cart ? action.response.cart : {}
			});
			document.dispatchEvent(new CustomEvent("update-cart", {}));
			return newState;

		case cartActionTypes.FETCH_ADDTOCART_FAILURE:
			newState = Object.assign({}, state, {
				// loading: false,
				messages: [],
				error: action.error,
				cart: {}
			});
			return newState;

		// ModifyCart
		case cartActionTypes.FETCH_MODIFYCART_REQUEST:
			newState = Object.assign({}, state, {
				error: null,
				messages: [],
				idItem: action.id,
				loadingItem: true
			});
			return newState;

		case cartActionTypes.FETCH_MODIFYCART_SUCCESS:
			analytics.Analytics.modifyCart(
				action.response ? action.response.cart : {},
				action.id,
				action.prevAmount,
				action.amount
			);

			// printMessages('ModifyCart', action.response ? action.response.messages : []);

			newState = Object.assign({}, state, {
				loadingItem: false,
				idItem: null,
				cart: action.response && action.response.cart ? action.response.cart : {}
			});
			document.dispatchEvent(new CustomEvent("update-cart", {}));
			return newState;

		case cartActionTypes.SET_ERROR_MESSAGE:
			newState = Object.assign({}, state, {
				messages: [{ value: action.message }]
			});
			return newState;

		default:
			// ALWAYS have a default case in a reducer
			return state;
	}
}
